var map = {
	"./bg.png": "3f6e",
	"./content_bg_long.png": "5f1c",
	"./content_bg_middle.png": "d716c",
	"./content_bg_short.png": "76cf",
	"./corner.png": "ab74",
	"./icon_1.png": "8f7b",
	"./icon_2.png": "a96d",
	"./icon_3.png": "ed50",
	"./icon_4.png": "b08b",
	"./icon_5.png": "7b79",
	"./icon_6.png": "cb3a",
	"./icon_7.png": "d6b2",
	"./jd.png": "d036",
	"./jiangduMap.png": "4ff8",
	"./jumpImg.png": "e313",
	"./nationFlag.png": "0146",
	"./nav_bg_1.png": "82e4",
	"./nav_bg_2.png": "a33e",
	"./nav_bg_3.png": "e04a",
	"./nav_bg_4.png": "5d13",
	"./nav_bg_5.png": "8c5a",
	"./nav_icon_1.png": "e643",
	"./nav_icon_2.png": "da62",
	"./nav_icon_3.png": "307a7",
	"./nav_icon_4.png": "312d",
	"./nav_icon_5.png": "fc89",
	"./tab_bg.png": "fe0a",
	"./tab_content_bg.png": "b864",
	"./tab_unactive_bg.png": "d28f2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";